import {request} from './request';

export default {
    async register(fields) {
        const rv = await request({
            url: '/api/legacy/cancellation/unemployed/register-bitrix',
            method: 'post',
            data: fields
        });

        return rv;
    }
}



// WEBPACK FOOTER //
// ./src/api/unemployed.js